process.nextTick(function() {
	delete require.cache[module.id];
	if(typeof window !== "undefined" && window.mochaPhantomJS)
		mochaPhantomJS.run();
	else
		mocha.run();
});



//////////////////
// WEBPACK FOOTER
// ./~/mocha-loader/start.js
// module id = 97
// module chunks = 3